import { createContext, useContext } from 'react';

// Global tenant context
export const TenantContext = createContext(null);

// Hook ile kolay erişim
export const useTenant = () => {
  return useContext(TenantContext);
};
